import React from "react";
import dayjs from "dayjs";

import { isNullOrUndefined } from "../../HWLibrary/HWUtils";

function MessageA77(props) {

  console.log(props, "PROPSS")
  const onMouseEnter = (e) => {
    if (!e.target) {
      return
    }
    if (e.target.disabled === true) {
      return
    }

    e.target.style.color = props.config?.customDesign?.messageA77ButtonMouseEnter?.color ?? "#f8f5f5";
    e.target.style.backgroundColor = props.config?.customDesign?.messageA77ButtonMouseEnter.background ?? "#2935dd";
  }

  const onMouseLeave = (e) => {
    if (!e.target) {
      return
    }

    e.target.style.color = props.config?.customDesign?.messageA77ButtonMouseLeave?.color ?? "#0092ed";
    e.target.style.backgroundColor = props.config?.customDesign?.messageA77ButtonMouseLeave.background ?? "#fff";
  }

  const messageContainerClassName = () => {
    return props.config.autoFullScreen ? "s360-message-cotainer-received-fs" : "s360-message-cotainer-received";
  }

  const messageBoxStyle = () => {
    return {
      borderWidth: '1px',
      borderStyle: 'solid',
      textAlign: 'left',
      borderColor: ' rgb(0, 95, 236)',
      width: 'fit-content',
      borderRadius: ' 0.2rem',
      color: 'rgb(0, 95, 236)',
      background: 'rgb(255, 255, 255)',
      marginLeft: '0.5rem',
      ...props.config?.customDesign?.messageA77Box
    }
  }

  const messageTimeStyle = () => {
    let config = props.config;
    return config?.customDesign?.messageA77Time;
  }


  const onMessageSend = () => {
    props.actions.sendMessageWithCode(props.entry.keyword, "I would like to Return to main menu");
    let n = document.getElementsByClassName("btn btn-chat");

    for (let i = 0; i < n.length; i++) {
      n[i].disabled = true;
    }
    document.getElementById(".mainMenuSVG").attr("onclick", "").unbind("click");
  }


  const isActiveConversation = () => {
    let isClosed = (props.activeConversation && props.activeConversation.active === false) || props.isConversationClosed;
    return !isClosed;
  }

  return (
    <div className={messageContainerClassName()}>
      <button disabled={props.disabled} title="Main Menu"
        className="btn btn-chat btn-check" onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={messageBoxStyle()}  {...(isActiveConversation() && { onClick: (e) => onMessageSend(e) })}>
        {isNullOrUndefined(props?.entry?.text)
          ? "I would like to return to main menu"
          : props?.entry?.text
        }
        <br />
      </button>
      {props.isLastEntry && props.sentTimestamp && <div className="s360-message-time-received" style={messageTimeStyle()}>
        {dayjs.unix(Math.trunc(props.sentTimestamp / 1000)).format("DD MMM h:mm a")}
      </div>}
    </div>
  )
}

export default MessageA77;
